module.exports = __webpack_public_path__ + "img/step3_get.f0c37939.png";